import abi from './contractData.json'

const contract = {
  address: '0x5bc2ae1263135fca2770fd4d1c743a3b2ab5e88c',
  abi: abi
}

export default contract;